import { render } from "./OrderItemsConfirmation.vue?vue&type=template&id=7fc35084"
import script from "./OrderItemsConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderItemsConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__